<!--Article Page-->
<template>
  <div
    v-loading.fullscreen.lock="mainLoader"
    element-loading-background="rgba(255, 255, 255, 0.8)"
    class="news-detail-page"
  >
    <div v-if="article">
      <news-header :image="imageForArticle"></news-header>

      <div class="news-content content-container">
        <div class="container">
          <el-row>
            <el-col
              :md="24"
              :lg="16"
              class="left-content"
            >
              <h2 class="news-title">
                {{ article.title }}
              </h2>
              <div class="d-flex mt-3">
                <div class="type-article">
                  Article
                </div>
                <small class="added-on">
                  Added : {{ formatDate(article.date) }}
                </small>
              </div>
              <hr class="content-hr" />
              <div
                class="news-content"
                v-html="content"
              ></div>   
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "../../../store";
import NewsHeader from "@/components/partials/news-header";
import beWellCmsApi from "@/services/be-well-cms.api";
import moment from 'moment';
export default {
  name: "NewsDetails",
  metaInfo: {
    title: "News & features"
  },
  components: {
    NewsHeader
  },
  data() {
    return {
      article: null,
      mainLoader: true,
    };
  },
  computed: {
    imageForArticle() {
      return this.article.has_feature_image
        ? this.article.feature_image.url
        : null;
    },
    content(){
      let cloneDiv = document.createElement("div");
      cloneDiv.innerHTML = this.$options.filters.domPurify(this.article?.content?.length ? this.article?.content[0].text : '');
      return cloneDiv.innerHTML.replaceAll('&nbsp;','')
    },
    formatDate(){
      return (date) => {
        return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY')
      }
    }
  },
  watch: {
    $route(to) {

      this.mainLoader = true;

      beWellCmsApi.show('articles',to.params.id)
        .then(response => {
          this.mainLoader = false;
          this.article = response.data;
        })
        .catch(() => {
          this.$router.push({ name: "News and Features" });
        });
    }
  },
  created() {
    if (store.state.user.isLogged) {
      this.fetchArticle();
    }
  },
  methods: {
    fetchArticle() {
      beWellCmsApi.show('articles',this.$route.params.id)
        .then(response => {
          this.article = response.data;
        })
        .catch(() => {
          this.$router.push({ name: "News and Features" });
        }).finally(()=>{this.mainLoader = false;});
    }
  }
};
</script>
